import api from "../services/api";

export default {
    namespaced: true,
    state: {
        orders: [],
        totalOrders: 0,
        loading: false,
        loadError: "",
        products: {
            ordersProducts: [],
            loading: false,
            loadError: "",
        }
    },  
    mutations: {
        setOrders(state, data) {
            state.orders = data;
        },
        setTotalOrders(state, data){
            state.totalOrders = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.orders = [];
            state.loadError = err;
        },
        setOrdersProducts(state, data) {
            state.products.ordersProducts = data;
        },
        loadingProducts(state) {
            state.products.loading = true;
            state.products.loadError = "";
        },
        loadProductsComplete(state) {
            state.products.loading = false;
        },
        loadProductsError(state, err) {
            state.products.orderProducts = [];
            state.products.loadError = err;
        }
    },
  
    actions: {
        loadOrders(context, options) {
            context.commit("loading");

            api.fetchOrders({
                params: options.params,
                success: function(response) {
                    context.commit("setOrders", response.data.Orders);
                    context.commit("setTotalOrders", response.data.TotalOrders);

                    if (options.success) {
                        options.success(response.data);
                    }
                },
                error: function(e) {
                    context.commit("loadError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        },
        loadOrdersProducts(context, options) {
            context.commit("loadingProducts");
            api.fetchOrderProducts({
                params: {
                    OrderID: options.orderID,
                    SearchSupplierIDs:options.SearchSupplierIDs
                },
                success: function(response) {
                    context.commit("setOrdersProducts", response.data.OrdersProducts);

                    if (options.success) {
                        options.success(response.data.OrdersProducts);
                    }
                },
                error: function(e) {
                    context.commit("loadProductsError", api.parseHttpRequestError(e));

                    if (options.error) {
                        options.error(e);
                    }
                },
                finally: function() {
                    context.commit("loadProductsComplete");

                    if (options.finally) {
                        options.finally();
                    }
                }
            });
        }
    }
}
